import React from "react";
import { Modal } from "react-bootstrap";
import Blocker from "./Blocker";
import Binding from "../../binding";
import { Link } from "react-router-dom";
export default class FavModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      checkedItems: {},
    };
  }

  onDelete = async (id) => {
    if (id) {
      const { fav } = this.props.context;
      this.setState({ pending: true });
      await fav.deleteItem(id);
      this.setState({ pending: false });
    }
  };

  onDeleteChecked = async () => {
    let { checkedItems } = this.state;
    const { fav } = this.props.context;
    this.setState({ pending: true });
    await fav.deleteItems(Object.keys(checkedItems));
    this.setState({ pending: false });
  };

  onItemCheck = (id) => {
    let { checkedItems } = this.state;
    if (checkedItems[id]) {
      checkedItems[id] = false;
    } else {
      checkedItems[id] = true;
    }
    this.setState({ checkedItems });
  };

  onItemCheckAll = () => {
    let checkedItems = {};
    const { fav } = this.props.context;
    fav.favItems.forEach((item) => {
      checkedItems[item.id] = true;
    });
    this.setState({ checkedItems });
  };

  onItemUnCheckAll = () => {
    this.setState({ checkedItems: {} });
  };

  renderItem = (item = {}) => {
    const { checkedItems } = this.state;
    let binding = new Binding({
      id: item.id,
      entitycode: item.entitycode,
      classcode: item.classcode,
      typecode: item.typecode,
      label: item.label,
    });
    const typeDocument = binding.typedoc || {};

    return (
      <div
        key={item.id}
        className="py-5 border-bottom d-flex justify-content-between align-items-center"
      >
        <div className="flex-grow-1">
          <div className="d-flex">
            <label className="checkbox">
              <input
                type="checkbox"
                onChange={(e) => this.onItemCheck(item.id)}
                checked={checkedItems[item.id] ? true : false}
              />
              <span className="mr-2"></span>
            </label>
            <span
              className={`svg-icon mr-2 opacity-50 svg-icon-${typeDocument.iconColor}`}
            >
              {typeDocument.icon}
            </span>
            {this.renderItemLabel(item, binding)}
          </div>
        </div>

        <i
          title="Удалить"
          className="fa fa-times text-hover-danger cursor-pointer"
          onClick={() => this.onDelete(item.id)}
        ></i>
      </div>
    );
  };

  renderItemLabel = (item, binding) => {
    return (
      <>
        {binding.url ? (
          <Link
            onClick={() => this.props.onHide()}
            className="text-dark-50 text-hover-primary"
            to={`${binding.url}`}
          >
            {item.label}
          </Link>
        ) : (
          <>{item.label}</>
        )}
      </>
    );
  };

  render() {
    const { fav } = this.props.context;
    console.log("fav.favItems", fav.favItems);
    return (
      <>
        <Modal size="lg" show onHide={this.props.onHide}>
          <Modal.Header closeButton>
            <Modal.Title className="w-100">
              <div className="d-flex justify-content-between align-items-center">
                <div>Избранное</div>
                <div>
                  <div
                    className="btn btn-light mr-2"
                    onClick={this.onItemCheckAll}
                  >
                    <i className="fa fa-check-square-o mr-2"></i>Выбрать все
                  </div>
                  <div
                    className="btn btn-light mr-2"
                    onClick={this.onItemUnCheckAll}
                  >
                    <i className="fa fa-square-o mr-2"></i>Снять все
                  </div>
                  <div className="btn btn-light" onClick={this.onDeleteChecked}>
                    <i className="fa fa-times mr-2"></i>Удалить выбранные
                  </div>
                </div>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Blocker on={this.state.pending} hAuto>
              {fav.favItems.map((item) => this.renderItem(item))}
            </Blocker>
          </Modal.Body>
          <Modal.Footer>
            <button onClick={this.props.onHide} className="btn btn-light">
              Отмена
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
